import { render, staticRenderFns } from "./MedcinRegister.vue?vue&type=template&id=eb7449fe&scoped=true&class=bgpage&"
import script from "./MedcinRegister.vue?vue&type=script&lang=js&"
export * from "./MedcinRegister.vue?vue&type=script&lang=js&"
import style0 from "./MedcinRegister.vue?vue&type=style&index=0&id=eb7449fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb7449fe",
  null
  
)

export default component.exports